module.exports = __webpack_public_path__ + "static/favicon-4441084d561a2dafc5432628a09d8e93.png";